import React, { useState } from "react"
import clsx from "clsx"
import { useHistoricalAccessToolContext } from "contexts/HistoricalAccessToolContext"
import { useCustomName } from "hooks"
import { DEPARTMENT_KEY } from "utils/customNameHelpers"
import HistoricalAccessToolLocationFilterDetailsFacilitySelect from "./HistoricalAccessToolLocationFilterDetailsFacilitySelect"
import HistoricalAccessToolLocationFilterDetailsSelectedFacilities from "./HistoricalAccessToolLocationFilterDetailsFacilities"

const HistoricalAccessToolLocationFilterDetails = () => {
  const {
    addAllFacilityDepartmentsToReportableFieldLocationAnswerFilters,
    removeAllFacilityDepartmentsFromReportableFieldLocationAnswerFilters,
  } = useHistoricalAccessToolContext()

  const { pluralName: departmentsName } = useCustomName(DEPARTMENT_KEY)

  const [selectedFacilityIds, setSelectedFacilityIds] = useState([])

  const updateSelectedFacilities = (facilityIds) => {
    const currentSelectedFacilityIds = selectedFacilityIds

    const facilityIdsToAdd = facilityIds.filter((id) => !currentSelectedFacilityIds.includes(id))
    facilityIdsToAdd.forEach(addAllFacilityDepartmentsToReportableFieldLocationAnswerFilters)

    const facilityIdsToRemove = currentSelectedFacilityIds.filter((id) => !facilityIds.includes(id))
    facilityIdsToRemove.forEach(removeAllFacilityDepartmentsFromReportableFieldLocationAnswerFilters)

    setSelectedFacilityIds(facilityIds)
  }

  return (
    <>
      <HistoricalAccessToolLocationFilterDetailsFacilitySelect
        className={clsx(selectedFacilityIds.length > 0 && "mb-4")}
        onChange={updateSelectedFacilities}
        values={selectedFacilityIds}
      />
      {
        selectedFacilityIds.length > 0 && (
          <div>
            <span className="block mb-4">{departmentsName}:</span>
            <HistoricalAccessToolLocationFilterDetailsSelectedFacilities selectedFacilityIds={selectedFacilityIds} />
          </div>
        )
      }
    </>
  )
}

export default HistoricalAccessToolLocationFilterDetails
